import React from 'react';

import cn from 'classnames';

import styles from './Space.less';

export const Space: React.FC<{
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg';
  direction?: 'horizontal' | 'vertical';
}> = props => {
  const { size = 'sm', direction = 'horizontal' } = props;
  return (
    <div
      className={cn(styles.spaceContainer, {
        [styles.sizeXxs]: size === 'xxs',
        [styles.sizeXs]: size === 'xs',
        [styles.sizeSm]: size === 'sm',
        [styles.sizeMd]: size === 'md',
        [styles.sizeLg]: size === 'lg',
        [styles.vertical]: direction === 'vertical',
      })}
    >
      {props.children}
    </div>
  );
};
